export function redirect (url) { location.href = url; }

export function href () { return location.toString(); }

export default { redirect, href };
